import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';

import { createContext, useContext, useState, ReactNode } from 'react';

interface DashboardContextType {
  isUploadOpen: boolean;
  setIsUploadOpen: (isOpen: boolean) => void;
  activeId: string | null;
  setActiveId: (id: string | null) => void;
}

// Export the context so it can be imported from other files
export const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export function DashboardProvider({ children }: { children: ReactNode }) {
  useLanguage();
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [activeId, setActiveId] = useState<string | null>(null);
  
  return (
    <DashboardContext.Provider value={{ 
      isUploadOpen, 
      setIsUploadOpen,
      activeId,
      setActiveId
    }}>
      {children}
    </DashboardContext.Provider>
  );
}

export function useDashboard() {
  useLanguage();
  const context = useContext(DashboardContext);
  if (context === undefined) {
    throw new Error(translateInterfaceText("useDashboard must be used within a DashboardProvider"));
  }
  return context;
}
